import React, { useState } from 'react';
import { refreshActiveTable } from '@/store/reducers/table-slice';
import { hideModal } from '@/store/reducers/ui-slice';
import { Button, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useDispatch } from 'react-redux';
import { toast } from 'sonner';

import { InputType } from '@/types/general';
import { CustomConfigInputV2 } from '@/components/core/custom-config-input-v2';

function TopupModalContent({
  content,
}: {
  content: {
    opId: string;
    playerId: string;
    playerCode: string;
  };
}): React.JSX.Element {
  const currencies = [{ label: 'USD', value: 'USD' }];

  const [dto, setDto] = useState({
    currency: '',
    amount: '',
  });

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const handleClose = (): void => {
    dispatch(hideModal());
  };

  const handleSubmit = async (): Promise<void> => {
    setIsLoading(true);

    try {
      const response = await fetch(`/api/players/topup`, {
        method: 'PUT',
        body: JSON.stringify({
          opId: content?.opId,
          playerId: content?.playerId,
          playerCode: content?.playerCode,
          ...dto,
        }),
      });
      const result = await response.json();
      if (response.ok && result.success && result.data) {
        toast.success('Topup balance is completed successfully!');
        dispatch(hideModal());
        dispatch(refreshActiveTable());
      } else {
        toast.error('Error: 500 | Unable to topup player balance');
      }
    } catch (e) {
      toast.error('Error: 500 | Unable to topup player balance');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Stack spacing={3}>
      <Typography variant="h6">Topup</Typography>

      <Stack spacing={3}>
        <CustomConfigInputV2
          label="Currency"
          name="currency"
          value={dto.currency}
          type={InputType.SELECT}
          defaultData={dto}
          menuItems={currencies}
          setDefaultData={setDto}
        />
        <CustomConfigInputV2
          label="Amount"
          name="amount"
          value={dto.amount}
          type={InputType.NUMBER}
          defaultData={dto}
          setDefaultData={setDto}
        />
      </Stack>
      <Stack direction="row" spacing={3} sx={{ mt: 3, justifyContent: 'initial' }}>
        <Button type="button" color="secondary" onClick={handleClose} sx={{ flex: '1 1 auto' }}>
          Close
        </Button>

        <Button loading={isLoading} onClick={handleSubmit} color="error" sx={{ flex: '1 1 auto' }} variant="contained">
          Send
        </Button>
      </Stack>
    </Stack>
  );
}

export default TopupModalContent;
